<ng-template #content let-modal>
    <div class="modal-header p-3 bg-soft-info">
        <h5 class="modal-title" id="modal-title">
            <ng-container *ngIf="eventForm">
                {{ 't-new-event-calendar' | translate }}
            </ng-container>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()"
            aria-hidden="true"></button>
    </div>
    <div class="modal-body p-4">
        <form (ngSubmit)="saveEvent()" [formGroup]="eventForm" id="form-event" *ngIf="eventForm">
            <div class="row event-form">
                <div class="col-12"
                    *ngIf="data?.contactName || data?.contactEmail || data?.contactPhone || data?.propertyLabel || data?.location">
                    <div class="alert alert-soft-info mb-3">
                        <div class="fw-semibold mb-2">
                            {{ 't-calendar.t-event-name' | translate }}
                        </div>
                        <div class="small" *ngIf="data?.contactName">
                            {{ 't-contact' | translate }}: {{ data?.contactName }}
                        </div>
                        <div class="small" *ngIf="data?.contactEmail">
                            {{ 't-email' | translate }}: {{ data?.contactEmail }}
                        </div>
                        <div class="small" *ngIf="data?.contactPhone">
                            {{ 't-phone' | translate }}: {{ data?.contactPhone }}
                        </div>
                        <div class="small" *ngIf="data?.propertyLabel">
                            {{ 't-general.t-property-reference' | translate }}: {{ data?.propertyLabel }}
                        </div>
                        <div class="small" *ngIf="data?.location">
                            {{ 't-general.t-location' | translate }}: {{ data?.location }}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-9">
                            <div class="mb-3">
                                <label class="form-label">
                                    {{ 't-calendar.t-event-type' | translate}}
                                </label>
                                <ng-select [multiple]="false"
                                    placeholder="{{ 't-general.t-select' | translate}} {{ 't-calendar.t-event-type' | translate}}"
                                    formControlName="type" required
                                    [ngClass]="{ 'is-invalid': submitted && form['type'].errors }"
                                    (change)="onChangeEventType($event)">
                                    <ng-option [value]="opt.id" *ngFor="let opt of eventTypes">
                                        <span class="ms-1">{{opt.translate |
                                            translate}}</span>
                                    </ng-option>
                                </ng-select>
                                <div *ngIf="submitted && form['type'].errors" class="invalid-feedback" align="left">
                                    <div *ngIf="form['type'].errors['required']">
                                        {{'t-calendar.t-event-type' | translate }}
                                        {{'t-general.t-is-required' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 pt-lg-4 mb-3">
                            <!-- Switches Color -->
                            <div class="form-check form-switch pt-lg-2">
                                <input class="form-check-input" type="checkbox" role="switch" id="SwitchPublic"
                                    formControlName="isPublic">
                                <label class="form-check-label" for="SwitchPublic">
                                    {{'t-general.t-public' | translate }}
                                </label>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-12">
                    <div class="mb-3">
                        <label class="form-label">{{ 't-calendar.t-event-name' | translate }}</label>
                        <input class="form-control" placeholder=" {{ 't-calendar.t-event-name' | translate}}"
                            type="text" id="event-title" required formControlName="name"
                            [ngClass]="{ 'is-invalid': submitted && form['name'].errors }" />
                        <div *ngIf="submitted && form['name'].errors" class="invalid-feedback" align="left">
                            <div *ngIf="form['name'].errors['required']">
                                {{ 't-calendar.t-event-name' | translate}}
                                {{'t-general.t-is-required' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <!--end col-->
                <div class="col-12">
                    <div class="mb-3">
                        <label>{{ 't-calendar.t-event-date' | translate }}</label>
                        <div class="input-group">
                            <input class="form-control flatpickr-input" type="text"
                                placeholder=" {{ 't-general.t-select' | translate}}  {{ 't-calendar.t-event-date' | translate}}"
                                mwlFlatpickr [convertModelValue]="true" [dateFormat]="'Y-m-d'" formControlName="date"
                                required [ngClass]="{ 'is-invalid': submitted && form['date'].errors }"
                                (change)="onChangeDate($event)" />
                            <span class="input-group-text"><i class="ri-calendar-event-line"></i></span>
                            <div *ngIf="submitted && form['date'].errors" class="invalid-feedback" align="left">
                                <div *ngIf="form['date'].errors['required']">
                                    {{ 't-calendar.t-event-date' | translate}}
                                    {{'t-general.t-is-required' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end col-->
                <div class="col-12" id="event-time">
                    <div class="row">
                        <div class="col-6">
                            <div class="mb-3">
                                <label class="form-label">
                                    {{ 't-general.t-start-time' | translate}}
                                </label>
                                <div class="input-group">
                                    <input class="form-control flatpickr-input" type="text"
                                        placeholder="{{ 't-general.t-select' | translate}}  {{ 't-general.t-start-time' | translate}}"
                                        mwlFlatpickr [enableTime]="true" [convertModelValue]="true" [noCalendar]="true"
                                        [dateFormat]="'H:i'" formControlName="startHour" required
                                        [ngClass]="{ 'is-invalid': submitted && form['startHour'].errors }"
                                        [time24hr]="true" />
                                    <span class="input-group-text"><i class="ri-time-line"></i></span>
                                    <div *ngIf="submitted && form['startHour'].errors" class="invalid-feedback"
                                        align="left">
                                        <div *ngIf="form['startHour'].errors['required']">
                                            {{ 't-general.t-start-time' | translate}}
                                            {{'t-general.t-is-required' | translate }}
                                        </div>
                                    </div>
                                    <div *ngIf="submitted && !eventForm.valid && !form['endHour'].errors && !form['startHour'].errors && validRange()"
                                        class="invalid-feedback m-nt" align="left" style="display: block;">
                                        <div>
                                            {{ 't-calendar.t-start-hour-end-hour-is-not-valid' |
                                            translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3">
                                <label class="form-label">{{ 't-general.t-end-time' | translate
                                    }}</label>
                                <div class="input-group">
                                    <input class="form-control flatpickr-input" type="text"
                                        placeholder="{{ 't-general.t-select' | translate}}  {{ 't-general.t-end-time' | translate}}"
                                        mwlFlatpickr [enableTime]="true" [convertModelValue]="true" [noCalendar]="true"
                                        [dateFormat]="'H:i'" formControlName="endHour" required
                                        [ngClass]="{ 'is-invalid': submitted && form['endHour'].errors }"
                                        [time24hr]="true" />
                                    <span class="input-group-text"><i class="ri-time-line"></i></span>
                                    <div *ngIf="submitted && form['endHour'].errors" class="invalid-feedback"
                                        align="left">
                                        <div *ngIf="form['endHour'].errors['required']">
                                            {{ 't-general.t-end-time' | translate}}
                                            {{'t-general.t-is-required' | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end col-->
                <div class="col-12">
                    <div class="mb-3">
                        <label for="event-location">{{ 't-general.t-location' | translate }}</label>
                        <div>
                            <input type="text" class="form-control"
                                placeholder="{{ 't-general.t-location' | translate }}" formControlName="location">
                        </div>
                    </div>
                </div>
                <!--end col-->
                <div class="col-12">
                    <div class="mb-3">
                        <label class="form-label">{{ 't-general.t-description' | translate }}</label>
                        <textarea class="form-control" placeholder="{{ 't-general.t-description' | translate }}"
                            rows="3" spellcheck="false" formControlName="description"></textarea>
                    </div>
                </div>
                <div class="col-12" *ngIf="data?.ownerMeeting">
                    <div class="alert alert-soft-info mb-3">
                        Ao continuar, sera aberto o modal para editar o email que sera enviado ao proprietario.
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->
            <div class="hstack gap-2 justify-content-end">
                <button type="submit" class="btn btn-primary">
                    {{ data?.ownerMeeting ? 'Continuar' : ('t-save' | translate) }}
                </button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #ownerMailContent let-modal>
    <div class="modal-header p-3 bg-soft-info">
        <h5 class="modal-title">
            Editar email ao proprietario
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()"
            aria-hidden="true"></button>
    </div>
    <div class="modal-body p-4" *ngIf="eventForm" [formGroup]="eventForm">
        <div class="mb-3">
            <label class="form-label">Assunto do email</label>
            <input
                type="text"
                class="form-control"
                placeholder="Assunto do email"
                formControlName="emailSubject"
                [ngClass]="{ 'is-invalid': ownerMailSubmitted && form['emailSubject']?.errors }"
            />
            <div *ngIf="ownerMailSubmitted && form['emailSubject']?.errors" class="invalid-feedback" align="left">
                <div *ngIf="form['emailSubject']?.errors?.['required']">
                    Assunto obrigatorio
                </div>
            </div>
        </div>

        <div class="mb-3">
            <label class="form-label">Mensagem do email</label>
            <textarea
                class="form-control"
                rows="8"
                spellcheck="false"
                placeholder="Escreva a mensagem para o proprietario"
                formControlName="emailBody"
                [ngClass]="{ 'is-invalid': ownerMailSubmitted && form['emailBody']?.errors }"
            ></textarea>
            <div *ngIf="ownerMailSubmitted && form['emailBody']?.errors" class="invalid-feedback" align="left">
                <div *ngIf="form['emailBody']?.errors?.['required']">
                    Mensagem obrigatoria
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="backToEventModal()">
            Voltar
        </button>
        <button type="button" class="btn btn-primary" (click)="confirmOwnerMailAndSave()">
            Enviar e guardar
        </button>
    </div>
</ng-template>
